<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const title = computed(() => {
  switch (route.name) {
    case 'feedback':
      return 'Mein Feedback';
    case 'stay':
      return 'Mein Aufenthalt';
    case 'past-courses':
      return 'Vergangene Kurse';
    case 'massage':
      return 'Meine Massagen';
    case 'yogatherapy':
      return 'Meine Yogatherapie';
    case 'rides':
      return 'Mitfahrgelegenheiten';
    default:
      return '';
  }
});
</script>

<template>
  <div v-if="title" class="top-bar">
    <h2>{{ title }}</h2>
  </div>
</template>

<style scoped>
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background: #960040;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

h2 {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>